import { render, staticRenderFns } from "./AddThirdProject-view.vue?vue&type=template&id=6a918b78&scoped=true&"
import script from "./AddThirdProject-view.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddThirdProject-view.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AddThirdProject-view.vue?vue&type=style&index=0&id=6a918b78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a918b78",
  null
  
)

export default component.exports